import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-track-payouts',
  templateUrl: './track-payouts.component.html',
  styleUrls: ['./track-payouts.component.css']
})
export class TrackPayoutsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
